export const CONSENT_KEY = 'altruist_wellbeing_cookie_consent'

export function getCookieConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY)
  } catch {
    return null
  }
}

export function hasCookieConsent() {
  return getCookieConsent() === 'accepted'
}
